import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shijian",
  "use": "icon-shijian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shijian\"><path d=\"M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zM512 896c-211.2 0-384-172.8-384-384s172.8-384 384-384 384 172.8 384 384S723.2 896 512 896zM576 537.6 576 320c0-38.4-25.6-64-64-64S448 281.6 448 320l0 224c0 0 0 6.4 0 6.4 0 19.2 0 38.4 19.2 51.2l140.8 140.8c25.6 25.6 64 25.6 89.6 0 25.6-25.6 25.6-64 0-89.6L576 537.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shijian.svg
// module id = 0oTP
// module chunks = 12